import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { SupportedLocale, useSupportedLocales } from '@futrli/localisation';

import { TopBarMenu } from '../top-bar-menu/top-bar-menu';

interface ReportLocaleMenuProps {
  isTemplate?: boolean;
  onChange: (value: SupportedLocale['value']) => void;
  value: SupportedLocale['value'];
}

export const ReportLocaleMenu = ({ isTemplate, onChange, value }: ReportLocaleMenuProps) => {
  const intl = useIntl();
  const locales = useSupportedLocales();

  const label = isTemplate
    ? intl.formatMessage({ id: 'reporting.menu.template_locale', defaultMessage: 'Template locale' })
    : intl.formatMessage({ id: 'reporting.menu.report_locale', defaultMessage: 'Report locale' });
  const options = useMemo(() => locales.map(l => ({ label: l.text, value: l.value })), [locales]);

  return (
    <TopBarMenu<SupportedLocale['value']>
      label={label}
      options={options}
      name="test"
      onChange={onChange}
      value={value}
    />
  );
};
